import { render, staticRenderFns } from "./DateSelect.vue?vue&type=template&id=2184ba02"
import script from "./DateSelect.vue?vue&type=script&lang=js"
export * from "./DateSelect.vue?vue&type=script&lang=js"
import style0 from "./DateSelect.vue?vue&type=style&index=0&id=2184ba02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDatePicker,VIcon,VMenu,VSpacer,VTextField})
